import { useTranslation } from "react-i18next";

export default function LangSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "fr").slice(0, 2);

  const change = (lng) => {
    i18n.changeLanguage(lng);
    try { localStorage.setItem("i18nextLng", lng); } catch {}
  };

  return (
    <div className={`flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase ${className}`} data-testid="lang-switcher">
      <button
        data-testid="lang-fr"
        onClick={() => change("fr")}
        className={current === "fr" ? "text-[#D4AF37]" : "text-[#A3A39D] hover:text-[#F5F5F0]"}
      >
        FR
      </button>
      <span className="text-white/20">/</span>
      <button
        data-testid="lang-en"
        onClick={() => change("en")}
        className={current === "en" ? "text-[#D4AF37]" : "text-[#A3A39D] hover:text-[#F5F5F0]"}
      >
        EN
      </button>
    </div>
  );
}
